import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';

const Skeleton = ({ width, height, ...rest }) => {
  const classes = useStyle({ width, height });

  return (
    <div className={classes.skeleton} {...rest} />
  );
};

Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

Skeleton.defaultProps = {
  width: '50px',
  height: '50px',
};

export default Skeleton;
